import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
var UnauthorizedAccess = function () {
    var navigate = useNavigate();
    return (_jsxs(Box, { height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', px: 2, bgcolor: '#f9f9f9', children: [_jsx(LockOutlinedIcon, { sx: { fontSize: 80, color: '#d32f2f', mb: 2 } }), _jsx(Typography, { component: "div", variant: 'h3', sx: { fontWeight: 600, color: '#212121', mb: 1 }, children: "Unauthorized Access" }), _jsx(Typography, { component: "div", variant: 'h6', sx: {
                    maxWidth: '480px',
                    color: '#616161',
                    fontSize: '1.1rem',
                    mb: 4,
                    lineHeight: 1.6,
                }, children: "You are currently logged in but do not have the necessary permissions to view this page. If you believe this is an error, please contact your administrator." })] }));
};
export default UnauthorizedAccess;
